import React, {Component} from "react";
import {Menu} from "antd";
import {NavLink} from 'react-router-dom';
import {injectIntl} from "react-intl";
import User from '../services/User'
import "./LeftMenu.css";
import connect from "react-redux/es/connect/connect";

const SubMenu = Menu.SubMenu;

class LeftMenu extends Component {

  state = {
    collapsed: false
  };

  toggleCollapsed = () => {
    this.setState({collapsed: !this.state.collapsed});
    document.body.classList.toggle('has-no-sidebar');
  };

  render() {
    const {intl:{formatMessage}, configurationHints} = this.props;

    const dealerDataHint = ['SALES_CONDITIONS', 'TIRE_BRANDS', 'MOBILITY', 'MOBILITY_DESCRIPTION', 'SERVICES', 'MAIN_SERVICES', 'RENTAL_CONFIGURATION_CONFIGURATION']
      .filter(value =>configurationHints.includes(value)).length > 0;

    const lockParkHint = ['LOCK_PARK_CODE']
      .filter(value=>configurationHints.includes(value)).length > 0;

    const weeklyPlanningHint = ['WEEKLY_PLANNING']
      .filter(value=>configurationHints.includes(value)).length > 0;

    return (
      <aside className="sidebar">
        <nav className="navigation" id="navigation" tabIndex="-1">
        <Menu
          inlineIndent={0}
              theme="light"
              mode="inline"
              inlineCollapsed={this.state.collapsed}
        className="navigation-menu">

          {User.isAdvisor() &&
          <Menu.Item className="navigation-menu__item" key="tasksMenu" >
            <NavLink to="/interventions" className="navigation-menu__link">
              <svg className="navigation-menu__icon icon-tasks"><use xlinkHref="#icon-tasks"/></svg>
              <span className="navigation-menu__label">{formatMessage({id:'menu.tasks'})}</span>
            </NavLink>
          </Menu.Item>}

          {User.isCallCenterAgent() &&
          <Menu.Item className="navigation-menu__item" key="callCenter" >
            <NavLink to="/interventions" replace className="navigation-menu__link">
              <svg className="navigation-menu__icon icon-phone"><use xlinkHref="#icon-phone"/></svg>
              <span className="navigation-menu__label">{formatMessage({id:'menu.callCenter'})}</span>
            </NavLink>
          </Menu.Item>}

          {User.isAdvisor() &&
          <SubMenu className="navigation-menu__item" key="planning" title={
            <span className="navigation-menu__link">
              <svg className={`navigation-menu__icon icon-calendar ${weeklyPlanningHint ? 'configuration-hint' : ''}`}><use
                xlinkHref="#icon-calendar"/></svg>
              <span className="navigation-menu__label">{formatMessage({id: 'menu.planning'})}</span>
            </span>
          }>
            <Menu.Item className="navigation-submenu__item" key="planningManagement">
              <NavLink to="/planning-management"
                       className={`navigation-submenu__link ${weeklyPlanningHint ? 'configuration-hint' : ''}`}>{formatMessage({id: 'submenu.planningManagement'})}</NavLink>
            </Menu.Item>
            <Menu.Item className="navigation-submenu__item" key="planningOverview">
              <NavLink to="/planning-overview"
                       className="navigation-submenu__link">{formatMessage({id: 'submenu.planningOverview'})}</NavLink>
            </Menu.Item>
          </SubMenu>}

          {User.isAdvisor() &&
          <SubMenu className="navigation-menu__item" key="rentalCarMenu" title={
            <span className="navigation-menu__link">
              <svg className="navigation-menu__icon icon-car"><use xlinkHref="#icon-car"/></svg>
              <span className="navigation-menu__label">{formatMessage({id:'menu.rentalCar'})}</span>
            </span>
          }>
            <Menu.Item className="navigation-submenu__item" key="carParkManagement">
              <NavLink to="/car-park-management" className="navigation-submenu__link">{formatMessage({id:'submenu.carParkManagement'})}</NavLink>
            </Menu.Item>
            <Menu.Item className="navigation-submenu__item" key="carParkPlanning">
              <NavLink to="/car-park-planning" className="navigation-submenu__link">{formatMessage({id:'submenu.parkPlanning'})}</NavLink>
            </Menu.Item>
            <Menu.Item className="navigation-submenu__item" key="carDelivery">
              <NavLink to="/car-delivery" className="navigation-submenu__link">{formatMessage({id:'submenu.carDelivery'})}</NavLink>
            </Menu.Item>
          </SubMenu>}

          {User.isAdvisor() &&
          <SubMenu className="navigation-menu__item" key="keySafe" title={
            <span className="navigation-menu__link">
              <svg className={`navigation-menu__icon icon-car ${lockParkHint ? 'configuration-hint' : ''}`}><use xlinkHref="#icon-key"/></svg>
              <span className="navigation-menu__label">{formatMessage({id:'menu.keySafe'})}</span>
            </span>
          }>
            <Menu.Item className="navigation-submenu__item" key="safesManagement">
              <NavLink to="/safes-management" className="navigation-submenu__link">{formatMessage({id:'submenu.safesManagement'})}</NavLink>
            </Menu.Item>
            <Menu.Item className="navigation-submenu__item" key="safesPlanning">
              <NavLink to="/safes-planning" className="navigation-submenu__link">{formatMessage({id:'submenu.safesPlanning'})}</NavLink>
            </Menu.Item>
            <Menu.Item className="navigation-submenu__item" key="codesConfiguration">
              <NavLink to="/codes-configuration" className={`navigation-submenu__link ${lockParkHint ? 'configuration-hint' : ''}`}>{formatMessage({id:'submenu.codesConfiguration'})}</NavLink>
            </Menu.Item>
          </SubMenu>}

          {User.isAdvisor() &&
          <SubMenu className="navigation-menu__item" key="tireWheels" title={
            <span className="navigation-menu__link">
              <svg className="navigation-menu__icon icon-tire"><use xlinkHref="#icon-tire"/></svg>
              <span className="navigation-menu__label">{formatMessage({id:'menu.tireWheels'})}</span>
            </span>
          }>
            <Menu.Item className="navigation-submenu__item" key="tireWheelsConfiguration">
              <NavLink to="/tire-configuration" className="navigation-submenu__link">{formatMessage({id:'submenu.tireConfiguration'})}</NavLink>
            </Menu.Item>
            <Menu.Item className="navigation-submenu__item" key="tireWheelsManagement">
              <NavLink to="/tire-management" className="navigation-submenu__link">{formatMessage({id:'submenu.tireManagement'})}</NavLink>
            </Menu.Item>
          </SubMenu>}

          {User.isAdvisor() &&
          <SubMenu className="navigation-menu__item" key="dealershipMenu" title={
            <span className="navigation-menu__link">
              <svg className={`navigation-menu__icon icon-warehouse ${dealerDataHint ? 'configuration-hint' : ''}`}><use xlinkHref="#icon-warehouse"/></svg>
              <span className="navigation-menu__label">{formatMessage({id:'menu.dealership'})}</span>
            </span>
          }>
            <Menu.Item className="navigation-submenu__item" key="myDealership">
              <NavLink to="/dealership" className={`navigation-submenu__link ${dealerDataHint ? 'configuration-hint' : ''}`}>{formatMessage({id:'submenu.myDealership'})}</NavLink>
            </Menu.Item>
            <Menu.Item className="navigation-submenu__item" key="communication">
              <NavLink to="/communication" className="navigation-submenu__link">{formatMessage({id:'submenu.communication'})}</NavLink>
            </Menu.Item>
          </SubMenu>}

          {User.isNscAdmin() &&
            <Menu.Item className="navigation-menu__item" key="nscCommunication" >
              <NavLink to="/communication" className="navigation-menu__link">
                <svg className="navigation-menu__icon icon-tasks"><use xlinkHref="#icon-tasks"/></svg>
                <span className="navigation-menu__label">{formatMessage({id:'menu.user-interface'})}</span>
              </NavLink>
            </Menu.Item>
          }
          </Menu>

          <button className="sidebar-trigger" onClick={this.toggleCollapsed}>
            <svg className="sidebar-trigger__icon"><use xlinkHref="#icon-arrow-left"/></svg>
            <span className="sidebar-trigger__label">{formatMessage({id:'menu.closeButton'})}</span>
          </button>
        </nav>
      </aside>
    );
  }
}

const mapStateToProps = state => ({
  configurationHints: state.dealerConfigurationCheck && state.dealerConfigurationCheck.configurationHints || [],
});

export default connect(mapStateToProps)(injectIntl(LeftMenu))



// WEBPACK FOOTER //
// ./src/layout/LeftMenu.js